import React__default from 'react';
import st from '../../../../../../../../styled-components/dist/styled-components.esm.mjs';
import { DiscountPrice } from '@vp/swan';
import { TokenReplace, RawPrice } from '@vp/vp-tokenized-fragment';
import { useProductOptionsTranslations } from '../../../product-options-translations/product-option-translations.mjs';

const InfoTextStyle = st.div `
  .swan-discount-price {
      color: var(--swan-sem-color-text-info);
  }
`;
const PromoTextStyle = st.div `
  color: var(--swan-sem-color-text-promo);
  font-size: var(--swan-sem-font-size-small);
`;
const Savings = ({ culture, currency, minimumFractionDigits, savingsFormat, savingsPercent = 0, savingsTotal = 0, onSale = false, }) => {
    const { i18n } = useProductOptionsTranslations();
    const saleText = savingsPercent > 0 ? "+ " + i18n("sale") : i18n("sale");
    if (savingsFormat === "percent") {
        const percentSavingsText = i18n("percentSavings");
        return (React__default.createElement(React__default.Fragment, null,
            savingsPercent > 0 && (React__default.createElement(InfoTextStyle, null,
                React__default.createElement(DiscountPrice, { fontSize: "small" },
                    React__default.createElement(TokenReplace, { tokenizedText: percentSavingsText, contextVariables: { PERCENT: `${savingsPercent}` } })))),
            onSale && React__default.createElement(PromoTextStyle, null,
                "\u00A0",
                saleText)));
    }
    else if (savingsFormat === "difference") {
        // TO DO - whoever owns VpTokenizedFragment would probably token engine replace savings experience
        return (React__default.createElement(React__default.Fragment, null,
            savingsTotal > 0 && (React__default.createElement(InfoTextStyle, null,
                React__default.createElement(DiscountPrice, { fontSize: "small" },
                    React__default.createElement(RawPrice, { placeHolderText: "...", pricingInfo: {
                            listPrice: savingsTotal,
                            discountPrice: savingsTotal,
                            minimumFractionDigits,
                            vatInc: true,
                            hideVatMessage: true,
                            hideShippingMessageInVatMessage: true,
                            culture,
                            currency,
                        } }),
                    " ",
                    "discount / unit"))),
            onSale && React__default.createElement(PromoTextStyle, null,
                "\u00A0",
                saleText)));
    }
    else {
        return React__default.createElement(React__default.Fragment, null);
    }
};

export { Savings };
//# sourceMappingURL=savings-format.mjs.map
